type Path<T> = T extends object
  ? {
      [K in keyof T & string]: T[K] extends object
        ? `${K}` | `${K}.${Path<T[K]>}`
        : `${K}`;
    }[keyof T & string]
  : never;

type PathValue<T, P extends string> = P extends keyof T
  ? T[P]
  : P extends `${infer K}.${infer Rest}`
    ? K extends keyof T
      ? T[K] extends object
        ? PathValue<T[K], Rest>
        : never
      : never
    : never;

export function getValueByPath<T, P extends Path<T>>(
  obj: T,
  path: P,
): PathValue<T, P>;

export function getValueByPath<T extends Record<string, unknown>>(
  obj: T,
  path: string,
): unknown;

export function getValueByPath<T extends Record<string, unknown>>(
  obj: T,
  path: string,
): unknown {
  const [key, ...rest] = path.split(".");

  if (!(key in obj)) {
    return undefined;
  }

  const value = obj[key];

  if (rest.length === 0) {
    return value;
  }

  if (value && typeof value === "object" && !Array.isArray(value)) {
    return getValueByPath(value as Record<string, unknown>, rest.join("."));
  }

  return undefined;
}
